export default __webpack_public_path__ + "static/media/Team Process - Equal.2f3fb8d7.png";